import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import Professional from '../../models/Professional'
import MedicalTeam from "../../models/MedicalTeam";
import MedicalTeamService from "../../services/MedicalTeamService";
import FormFieldBaseTyped from "../FormFieldBaseTyped";
import OptionItemTyped from "../../models/OptionItemTyped";
import Occupation from "../../models/Occupation";

export class ReRegistrationTeamMembersFormItem {
    Id: number;
    Participate: string | undefined;
    ParticipateValue: OptionItemTyped<MedicalTeam> | undefined;
    Occupation: string | undefined;
    OccupationValue: OptionItemTyped<Occupation> | undefined;
    RegistrationNumber: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;

    constructor(Id: number, RegistrationNumber: string) {
        this.Id = Id;
        this.RegistrationNumber = RegistrationNumber;
    }

    static NewInstance(): ReRegistrationTeamMembersFormItem {
        return new ReRegistrationTeamMembersFormItem(0, "");
    }

}

export default class ReRegistrationTeamMembersForm implements FormBase {

    Participate: FormFieldBaseTyped<OptionItemTyped<MedicalTeam>>;
    Occupation: FormFieldBaseTyped<OptionItemTyped<Occupation>>;
    FormItemList: ReRegistrationTeamMembersFormItem[];
    FormRemoveList: ReRegistrationTeamMembersFormItem[];
    FormItemToEdit: ReRegistrationTeamMembersFormItem;

    constructor(Participate: string, Occupation: string) {

        this.Participate = new FormFieldBaseTyped<OptionItemTyped<MedicalTeam>>(undefined, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.Occupation = new FormFieldBaseTyped<OptionItemTyped<Occupation>>(undefined, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.FormItemList = new Array<ReRegistrationTeamMembersFormItem>();
        this.FormRemoveList = new Array<ReRegistrationTeamMembersFormItem>();
        this.FormItemToEdit = ReRegistrationTeamMembersFormItem.NewInstance();
    }

    AddOrUpdateReRegistrationTeamMembersFormItem() {
        if (this.ValidateForm()) {

            //Insert
            if (this.FormItemToEdit === null || this.FormItemToEdit.Id === 0) {

                let item = ReRegistrationTeamMembersFormItem.NewInstance();
                item.Id = this.getNewId();
                item.RegistrationNumber = `${this.Participate.Value?.Value?.Acronym} ${this.Participate.Value?.Value?.NrCrm}`;
                item.Participate = this.Participate.Value?.Value?.Name;
                item.ParticipateValue = this.Participate.Value;
                item.Occupation = this.Occupation.Value?.Text;
                item.OccupationValue = this.Occupation.Value;
                this.FormItemList.push(item);

                //Update    
            } else {
                for (let index = 0; index < this.FormItemList.length; index++) {
                    const element = this.FormItemList[index];
                    if (element.Id === this.FormItemToEdit.Id) {


                        let item = ReRegistrationTeamMembersFormItem.NewInstance();
                        item.Id = element.Id;
                        item.RegistrationNumber = `${this.Participate.Value?.Value?.Acronym} ${this.Participate.Value?.Value?.NrCrm}`;
                        item.Participate = this.Participate.Value?.Value?.Name;
                        item.ParticipateValue = this.Participate.Value;
                        item.Occupation = this.Occupation.Value?.Text;
                        item.OccupationValue = this.Occupation.Value;
                        item.RemoveTasy = element.RemoveTasy;
                        item.TasyCode = element.TasyCode;

                        this.FormItemList[index] = item;
                    }
                }
            }
            this.ResetForm();
        }
    }

    CallInsertOrUpdateApi(Professional: Professional): Promise<boolean> {
        const dataJson = this.getJsonObjet();
        return MedicalTeamService.postInsertOrUpdateMedicalTeam(dataJson, Professional.Id);
    }

    async PreloadFormFromApi(requestId: string): Promise<any> {


        return await MedicalTeamService.CreateAndGetMedicalTeamFromTasy(requestId).then((data: MedicalTeam[]) => {

            this.FormItemList = new Array<ReRegistrationTeamMembersFormItem>();
            this.FormRemoveList = new Array<ReRegistrationTeamMembersFormItem>();

            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                let optionParticipate: OptionItemTyped<any> | undefined = undefined;

                if (element.Name !== undefined && element.PhysicalPersonTasyCode !== undefined) {
                    let NameFormated = `${element.Name} ${element.Acronym}: ${element.NrCrm}`
                    let teamValue = {
                        Acronym: element.Acronym,
                        NrCrm: element.NrCrm,
                        Description: element.Name,
                        Name: element.Name,
                        Text: element.Name,
                        Id: element.PhysicalPersonTasyCode
                    }
                    optionParticipate = new OptionItemTyped(element.PhysicalPersonTasyCode, NameFormated, teamValue);
                }

                let optionOccupation: OptionItemTyped<any> | undefined = undefined;

                if (element.OccupationName !== undefined && element.OccupationTasyCode !== undefined && element.OccupationTasyCode !== null) {
                    optionOccupation = new OptionItemTyped(element.OccupationTasyCode, element.OccupationName, element.OccupationTasyCode.toString());
                }

                let item = ReRegistrationTeamMembersFormItem.NewInstance();
                item.Id = this.getNewId();
                item.RegistrationNumber = `${element.Acronym} ${element.NrCrm}`;
                item.Participate = element.Name;
                item.ParticipateValue = optionParticipate;
                item.Occupation = element.OccupationName;
                item.OccupationValue = optionOccupation;
                item.RemoveTasy = element.RemoveTasy;
                item.TasyCode = element.TasyCode;

                this.FormItemList.push(item);

            }

        });
    }

    EditReRegistrationTeamMembersFormItem(id: number) {
        this.ResetForm();

        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];

            if (element.Id === id) {
                this.FormItemToEdit = element;
                this.Participate.Value = this.FormItemToEdit.ParticipateValue;
                this.Occupation.Value = this.FormItemToEdit.OccupationValue;
            }
        }
    }

    RemoveReRegistrationTeamMembersFormItem(id: number) {
        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];
            if (element.Id === id) {
                if (element.TasyCode === undefined || element.TasyCode === 0) {
                    this.FormItemList.splice(index, 1);
                } else {
                    element.RemoveTasy = true;
                    this.FormRemoveList.push(element);
                    this.FormItemList.splice(index, 1);
                }
            }
        }
    }


    static NewInstance(): ReRegistrationTeamMembersForm {
        return new ReRegistrationTeamMembersForm("", "");
    }

    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }


    ValidateToGoNextStep(): string {
        if (this.FormItemList.length > 0) {

            for (let index = 0; index < this.FormItemList.length; index++) {
                const element = this.FormItemList[index];
                if(element.OccupationValue === undefined || element.OccupationValue === null){
                    return "Por favor, todos os participantes em sua equipe precisa ter uma Profissão/Ocupação definida."
                }
            }

        }
        return "";
    }

    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            this.GetFieldByName(element).Value = "";
            this.GetFieldByName(element).Error = "";
        }

        this.FormItemToEdit = ReRegistrationTeamMembersFormItem.NewInstance();
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Participate":
                return this.Participate;
            case "Occupation":
                return this.Occupation

            default:
                return new FormFieldBase("", []);
        }
    }


    getNewId(): number {
        if (this.FormItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.FormItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }


    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];

        if (this.FormItemList !== null && this.FormItemList.length > 0) {
            this.FormItemList.forEach((element: ReRegistrationTeamMembersFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "nrCrm": element.ParticipateValue?.Value?.NrCrm,
                    "acronym": element.ParticipateValue?.Value?.Acronym,
                    "Name": element.Participate,
                    "physicalPersonTasyCode": element.ParticipateValue?.Value?.Id,
                    "occupationTasyCode": element.OccupationValue?.Id,
                    "occupationName": element.OccupationValue?.Text,
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        if (this.FormRemoveList !== null && this.FormRemoveList.length > 0) {
            this.FormRemoveList.forEach((element: ReRegistrationTeamMembersFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "nrCrm": element.ParticipateValue?.Value?.NrCrm,
                    "acronym": element.ParticipateValue?.Value?.Acronym,
                    "Name": element.Participate,
                    "physicalPersonTasyCode": element.ParticipateValue?.Value?.Id,
                    "occupationTasyCode": element.OccupationValue?.Id,
                    "occupationName": element.OccupationValue?.Text,
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }


        return viewModelList;
    }
}